import { FormattedMessage } from 'react-intl';

import { isCanonicalServiceType, parseServiceOrderStopName } from '#domain/serviceOrderStopName.ts';

export const ServiceTypeName = ({ value }: { value: string }) => {
    const { serviceType } = parseServiceOrderStopName(value);
    return isCanonicalServiceType(serviceType) ? (
        <FormattedMessage
            id={`intl-msg:ordercom-cloud-frontend.service.type.${serviceType}`}
            defaultMessage={serviceType}
        />
    ) : (
        serviceType
    );
};
